/* Puff Land – produits vus récemment (liste locale, cartes chargées via la Section Rendering API) */
(() => {
  'use strict';
  if (customElements.get('recently-viewed')) return;
  class RecentlyViewed extends HTMLElement {
    connectedCallback() {
      let list = [];
      try { list = JSON.parse(localStorage.getItem('pl_recent') || '[]') || []; } catch (e) { list = []; }
      const exclude = this.dataset.exclude;
      const limit = Number(this.dataset.limit) || 8;
      list = list.filter((h) => typeof h === 'string' && h && h !== exclude).slice(0, limit);
      if (!list.length) return;
      const run = () => this.load(list);
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => { if (entries[0].isIntersecting) { io.disconnect(); run(); } }, { rootMargin: '0px 0px 400px 0px' });
        io.observe(this.parentElement || this);
      } else run();
    }
    async load(handles) {
      const base = this.dataset.base || '/';
      const track = this.querySelector('[data-recent-track]');
      const cards = await Promise.all(handles.map((h) =>
        fetch(`${base}products/${encodeURIComponent(h)}?section_id=product-card-ajax`)
          .then((r) => (r.ok ? r.text() : ''))
          .catch(() => '')
      ));
      let count = 0;
      cards.forEach((html) => {
        const tpl = document.createElement('template');
        tpl.innerHTML = html;
        const card = tpl.content.querySelector('.card-product');
        if (!card) return;
        const li = document.createElement('li');
        li.className = 'slider__slide';
        li.appendChild(card);
        track.appendChild(li);
        count += 1;
      });
      if (!count) return;
      this.hidden = false;
      if (window.PL && window.PL.u && window.PL.u.initWishlistButtons) window.PL.u.initWishlistButtons(this);
    }
  }
  customElements.define('recently-viewed', RecentlyViewed);
})();
